import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, App } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import MainApp from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

const themeConfig = {
  token: {
    colorPrimary: '#1677ff',
    colorSuccess: '#16a34a',
    colorWarning: '#d97706',
    colorError: '#dc2626',
    colorInfo: '#1677ff',
    borderRadius: 6,
    borderRadiusLG: 8,
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f5f7fa',
    colorText: '#1f2937',
    colorTextSecondary: '#6b7280',
    colorBorder: '#e5e7eb',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: 14,
    controlHeight: 36,
    controlHeightLG: 40,
  },
  components: {
    Menu: {
      itemBorderRadius: 6,
      itemMarginInline: 0,
      itemMarginBlock: 4,
    },
    Card: {
      borderRadiusLG: 8,
      paddingLG: 24,
    },
    Button: {
      borderRadius: 6,
      controlHeight: 36,
      controlHeightLG: 40,
      paddingInline: 16,
    },
    Table: {
      borderRadius: 8,
      headerBg: '#f8fafc',
      headerColor: '#374151',
      rowHoverBg: '#f8fafc',
    },
    Modal: {
      borderRadiusLG: 8,
    },
    Input: {
      borderRadius: 6,
      controlHeight: 40,
    },
    Tabs: {
      colorBgContainer: 'transparent',
      inkBarColor: '#1677ff',
      itemActiveColor: '#1677ff',
      itemHoverColor: '#1677ff',
    },
    Tag: {
      borderRadius: 4,
    },
  },
};

root.render(
  <React.StrictMode>
    <ConfigProvider 
      locale={zhCN} 
      theme={themeConfig}
      modal={{
        maskClosable: true,
      }}
    >
      <App>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <MainApp />
        </BrowserRouter>
      </App>
    </ConfigProvider>
  </React.StrictMode>
);
